import { NextButton, PrimaryButtonMTV2, RoundButton } from '../buttons/Buttons';

type Props = {
	activeIndex: number;
	onNext: () => void;
	onSubmit: () => void;
	lastIndex: number;
	id: string;
	disabled?: boolean;
};

const Footer = (props: Props) => {
	const { activeIndex, lastIndex, onNext, onSubmit, id, disabled } = props;
	return activeIndex !== lastIndex ? (
		<div>
			<NextButton
				disabled={disabled}
				id={id}
				onClick={onNext}
				width=""
				withIcon={false}
			/>
		</div>
	) : (
		<div>
			<PrimaryButtonMTV2
				disabled={disabled}
				id={id}
				onClick={onSubmit}
				label="Save"
			/>
		</div>
	);
};

export default Footer;
